export const getAddFiltersDisplayStrategy = (assessmentType)=>{
    const strategies = {
        dependentOnRoot: hideRootFilterGroup,
        independent: showAll,
    };

    if(! strategies[assessmentType]){
        return showAll;
    }

    return strategies[assessmentType];
};

const showAll = (assessment, filterGroups) => {
    return filterGroups.filter(group => Object.keys(group).length > 0);
}

const hideRootFilterGroup = (assessment, filterGroups) => {
    const rootPrompt = assessment.rootPrompt;

    let filtersToDisplay = [];

    filterGroups.forEach( filterGroup => {
        const filterCategory = filterGroup.filterCategory;

        if (filterCategory && filterCategory.toLowerCase() != rootPrompt) {
            filtersToDisplay.push(filterGroup);
        }
        //need conditional to not show filtegroups that were not selected?
    });

    return filtersToDisplay;
}
